import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolParametroAutonomiaListComponent } from './list/rol-parametro-autonomia-list.component';
import { RolParametroAutonomiaRoutingModule } from './rol-parametro-autonomia.routing';
import { RolParametroAutonomiaComponent } from './rol-parametro-autonomia.component';
import { LoaderModule } from 'src/app/shared/loader/loader.module';
import { SnackbarModule } from 'src/app/shared/snackbar/snackbar.module';
import { SectionBarModule } from 'src/app/shared/sectionbar/sectionbar.module';
import { MatButtonModule, MatIconModule, MatInputModule, MatTableModule } from '@angular/material';
import { GridEmptyModule } from 'src/app/shared/gridempty/gridempty.module';
import { RolParametroAutonomiaSaveComponent } from './save/rol-parametro-autonomia-save.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FabButtonGroupModule } from 'src/app/shared/fabbuttongroup/fabbuttongroup.module';

@NgModule({
  imports: [
    CommonModule,
    RolParametroAutonomiaRoutingModule,
    LoaderModule,
    SnackbarModule,
    SectionBarModule,
    MatTableModule,
    GridEmptyModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    FabButtonGroupModule,
    MatIconModule,
  ],
  declarations: [
    RolParametroAutonomiaListComponent,
    RolParametroAutonomiaSaveComponent,
    RolParametroAutonomiaComponent,
  ],
  exports: [
    RolParametroAutonomiaComponent,
    RolParametroAutonomiaListComponent,
    RolParametroAutonomiaSaveComponent,
  ],
})
export class RolParametroAutonomiaModule { }
